import { createSvgComponent } from "../../icon/createSvgComponent";
import ShoppingBasketFill from "@core/icon/assets/shopping-basket-fill.svg";
export default createSvgComponent(ShoppingBasketFill);